import { VehicleInformation } from "../data/VehInfo";
import { useSelectedVehicle } from "../context/vehicle.context";

const VehicleStatus = ()=>{

    const { selVehData } = useSelectedVehicle();

    console.log("Vehicle Status Data: ", selVehData);

    return (
        <div className="vehicle-status">
            <h2>Status</h2>
            <div className="vehicleState">
                <h3>Weapons: </h3><span>{selVehData.kills.weapon ? "❌ KILLED" : "✅ GOOD"}</span><br/>
                <h3>Mobility: </h3><span>{selVehData.kills.mobility ? "❌ KILLED" : "✅ GOOD"}</span><br/>
                <h3>Comms: </h3><span>{selVehData.kills.comms ? "❌ KILLED" : "✅ GOOD"}</span><br/>
                <h3>Total: </h3><span>{selVehData.kills.total ? "❌ KILLED" : "✅ GOOD"}</span><br/>

            </div>
        </div>
    )
}

export default VehicleStatus;